<template>
  <div>
    <InspectModal ref="InspectModal"></InspectModal>
    <ContainerLogs ref="ContainerLogs"></ContainerLogs>
    <ExcludingContainer ref="ExcludingContainer" v-on:callback="getInfo();getClusterContainersData()"></ExcludingContainer>
    <DeleteCluster ref="DeleteCluster" v-on:callback="$router.push({name: 'container_cluster'})"></DeleteCluster>
    <JoinExistedContainer ref="JoinExistedContainer" v-on:callback="getInfo();getClusterContainersData()"></JoinExistedContainer>
    <TemplateSelector ref="TemplateSelector" v-on:selectOk="selectTemplateOk"></TemplateSelector>
    <Deploy ref="Deploy" v-on:deploySuccess="getInfo"></Deploy>
    <Modal v-model="redeployYAMLModal" ref="redeployYAMLModal" title="重新部署容器" width="800">
      <Alert v-if="redeployYAMLError" type="error" show-icon>{{ redeployYAMLError }}</Alert>
      <Alert show-icon type="warning">重新部署将删除原有容器，确定要重新部署容器吗？</Alert>
      是否修改配置:
      <i-switch v-model="redeployForm.renew_config">
        <span slot="open">是</span>
        <span slot="close">否</span>
      </i-switch>
      <codemirror ref="myCm" v-model="redeployForm.yaml" :options="cmOption" style="margin-top: 5px" v-if="redeployForm.renew_config"></codemirror>
      <div slot="footer">
        <Button type="warning" @click="reDeploySubmit" :loading="reDeploying">重新部署</Button>
        <Button @click="redeployYAMLModal = false">取消</Button>
      </div>
    </Modal>
    <Modal v-model="yamlShowModal" ref="yamlShowModal" title="YAML" width="800" footer-hide>
      <codemirror ref="myCmYaml" v-model="showYamlContent" :options="cmOption" style="margin-top: 5px" v-if="showYamlContent"></codemirror>
    </Modal>
    <Card shadow>
      <Row :style="{marginBottom: '10px'}">
        <div :style="{float: 'left'}">
          <Button size="small" icon="ios-arrow-back" @click="$router.push({name: 'container_cluster'})">返回列表</Button>
        </div>
      </Row>
      <div class="content">
        <div class="main">
          <div>
            <Row class="title">
              <h4 :style="{float: 'left'}">集群详情</h4>
            </Row>
            <Spin fix v-if="infoGetting"></Spin>
            <Alert v-else-if="infoError" type="warning" show-icon>获取数据失败</Alert>
            <div class="info-property" v-else>
              <dl>
                <dt>集群名称</dt><dd>{{ info.name }}</dd>
              </dl>
              <dl>
                <dt>集群状态</dt><dd><Badge status="success"/>运行中</dd>
              </dl>
              <dl>
                <dt>部署堆栈</dt>
                <dd v-if="info.stack">
                  <a v-on:click="$router.push({name: 'container_stack_detail', params: {id: info.stack.id}})">{{ info.stack.name }}</a>
                </dd>
              </dl>
              <dl>
                <dt>部署用户</dt>
                <dd v-if="info.created_user">{{ info.created_user.name ? info.created_user.name : info.created_user.username }}</dd>
              </dl>
              <dl>
                <dt>部署时间</dt>
                <dd v-if="info.created_at">{{ moment(info.created_at).format('YYYY-MM-DD HH:mm:ss') }} （<Time :time="info.created_at" :interval="60"/>）</dd>
              </dl>
              <dl>
                <dt>操作</dt>
                <dd>
                  <Dropdown transfer @on-click="joinContainer">
                    <Button type="primary" size="small">
                      增加容器
                      <Icon type="ios-arrow-down"></Icon>
                    </Button>
                    <DropdownMenu slot="list">
                      <DropdownItem name="existed-container">已存在的容器</DropdownItem>
                      <DropdownItem name="deploy-new-container">从模板新部署</DropdownItem>
                    </DropdownMenu>
                  </Dropdown>
                  <Divider type="vertical"/>
                  <Button type="error" size="small" @click="$refs.DeleteCluster.showModal($route.params.id)">销毁集群</Button>
                </dd>
              </dl>
            </div>
            <Row class="title" style="margin-top: 10px">
              <h4 :style="{float: 'left'}">运行容器<span style="color: #999">（{{ Object.keys(info.configs).length }}）</span></h4>
            </Row>
            <Row>
              <span>排序：</span>
              <Select v-model="ordering" size="small" style="width:100px; margin-right: 5px" clearable>
                <Option v-for="item in orderList" :value="item.value" :key="item.value">{{ item.label }}</Option>
              </Select>
              <i-switch size="large" style="margin-right: 5px" v-if="ordering" v-model="ascending">
                <span slot="open">反序</span>
                <span slot="close">正序</span>
              </i-switch>
              <Button type="primary" size="small" @click="getClusterContainersData" icon="md-refresh" :loading="containersGetting">刷新</Button>
            </Row>
            <Divider/>
            <div v-if="containers">
              <Alert v-if="redeployError" type="error" show-icon>{{ redeployError }}</Alert>
              <Alert show-icon type="error" v-for="(item, index) in containers.error" :key="index">{{ item }}</Alert>
              <List :loading="containersGetting">
                <ListItem v-for="item in containers.not_exists" :key="item.Id">
                  <div class="ivu-list-item-meta-avatar">
                    <span class="ivu-avatar ivu-avatar-circle ivu-avatar-image ivu-avatar-default">
                      <Icon type="iconfont icon-docker" style="font-family: iconfont" size="20" color="#25B8EB" />
                    </span>
                  </div>
                  <ListItemMeta>
                    <span slot="title">{{ item.Id }}</span>
                    <span slot="description">
                      <span style="color: red">未找到此容器</span>
                      <Divider type="vertical"/>
                      <span>节点：{{ item.node_name }}</span>
                      <Divider type="vertical"/>
                      <span>镜像：{{ item.image }}</span>
                    </span>
                  </ListItemMeta>
                  <template slot="action">
                    <li class="cluster-container-list-li">
                      <Tooltip>
                        <div slot="content">
                          <p>将容器从集群中剔除，</p>
                          <p>可选择是否同时销毁容器</p>
                        </div>
                        <a style="color: #ed4014" v-on:click="$refs.ExcludingContainer.showModal($route.params.id, item.Id, false)">剔除</a>
                      </Tooltip>
                    </li>
                    <li class="cluster-container-list-li">
                      <Tooltip content="重新部署此容器">
                        <a style="color: #ff9900" v-on:click="redeploy(item)">重新部署</a>
                      </Tooltip>
                    </li>
                  </template>
                </ListItem>
                <ListItem v-for="(item, index) in containers.data" :key="item.Id">
                  <ActionMenu ref="ActionMenu" v-on:callback="actionCallBack" :container="item" :show="false"></ActionMenu>
                  <div class="ivu-list-item-meta-avatar">
                    <span class="ivu-avatar ivu-avatar-circle ivu-avatar-image ivu-avatar-default">
                      <Icon type="iconfont icon-docker" style="font-family: iconfont" size="20" color="#25B8EB" />
                    </span>
                  </div>
                  <ListItemMeta>
                    <a slot="title" v-on:click="$router.push({name: 'container_detail', params: {nodeId: item.node_id, id: item.Id}})">
                      <span>{{ item.Name.startsWith('/') ? item.Name.substr(1) : item.Name }}</span>
                      <!--<span style="color: rgba(0, 0, 0, 0.45); margin-left: 10px">{{ item.Id }}</span>-->
                    </a>
                    <span slot="description">
                    <span>
                      <span v-if="item.State.Status === 'running'">
                        <span style="font-weight: bold" :style="{color: '#19be6b'}">Up </span>
                        <Time :time="item.State.StartedAt" :interval="60" style="color: #999"/>
                        <span v-if="item.State.Health">
                          <span style="font-weight: bold" :style="{color: '#19be6b'}"
                                v-if="item.State.Health.Status === 'healthy'"> ({{ item.State.Health.Status }})</span>
                          <span style="font-weight: bold" :style="{color: '#ed4014'}"
                                v-else-if="item.State.Health.Status === 'unhealthy'"> ({{ item.State.Health.Status }})</span>
                          <span style="font-weight: bold" :style="{color: '#ff9900'}"
                                v-else> ({{ item.State.Health.Status }})</span>
                        </span>
                      </span>
                      <span v-else-if="item.State.Status === 'paused'">
                        <span style="font-weight: bold" :style="{color: '#ff9900'}">Up </span>
                        <Time :time="item.State.StartedAt" :interval="60" style="color: #999"/>
                        <span style="font-weight: bold" :style="{color: '#ff9900'}"> (paused)</span>
                      </span>
                      <span v-else-if="item.State.Status === 'exited'">
                        <span style="font-weight: bold" :style="{color: '#ed4014'}">Exited ({{ item.State.ExitCode }}) </span>
                        <Time :time="item.State.FinishedAt" :interval="60" style="color: #999"/>
                      </span>
                      <span v-else>
                        <span style="font-weight: bold" :style="{color: '#ed4014'}">{{ item.State.Status }}</span>
                      </span>
                    </span>
                    <Divider type="vertical"/>
                    <span>节点：{{ item.node_name }}</span>
                    <Divider type="vertical"/>
                    <span>镜像：{{ item.Config ? item.Config.Image : item.Image }}</span>
                    <Divider type="vertical"/>
                    <span><a v-on:click="$refs.ContainerLogs.getLogs(item.Id, item.node_id)">日志</a></span>
                    <Divider type="vertical"/>
                    <span><a v-on:click="$refs.InspectModal.showModal(item.Id, item.node_id)">Inspect</a></span>
                    <span v-if="item.yaml">
                      <Divider type="vertical"/>
                      <span><a v-on:click="yamlView(item)">YAML</a></span>
                    </span>
                  </span>
                  </ListItemMeta>
                  <template slot="action">
                    <li class="cluster-container-list-li" v-if="item.State.Status === 'exited'">
                      <Button type="text" size="small" :loading="actionLoading" @click="action(index, 'start')">
                        <a><Icon style="font-family: 'iconfont';" type="iconfont icon-run" color="#19be6b" size="14"/> 启动</a>
                      </Button>
                    </li>
                    <li class="cluster-container-list-li" v-if="item.State.Status === 'running' || item.State.Status === 'paused'">
                      <Button type="text" size="small" :loading="actionLoading" @click="action(index, 'restart')">
                        <a><Icon type="md-refresh-circle" color="#ff9900" size="15" /> 重启</a>
                      </Button>
                    </li>
                    <li class="cluster-container-list-li" v-if="item.State.Status === 'paused'">
                      <Button type="text" size="small" :loading="actionLoading" @click="action(index, 'unpause')">
                        <a><Icon type="md-checkmark-circle" color="#19be6b" size="15"/> 恢复</a>
                      </Button>
                    </li>
                    <li class="cluster-container-list-li" v-if="item.State.Status === 'running'">
                      <Button type="text" size="small" :loading="actionLoading" @click="action(index, 'pause')">
                        <a><Icon style="font-family: 'iconfont'" type="iconfont icon-pause" size="17" color="#ff9900"/> 暂停</a>
                      </Button>
                    </li>
                    <li class="cluster-container-list-li" v-if="item.State.Status === 'running' || item.State.Status === 'paused' || item.State.Status === 'restarting'">
                      <Button type="text" size="small" :loading="actionLoading" @click="action(index, 'stop')">
                        <a><Icon style="font-family: 'iconfont'" type="iconfont icon-stop" size="13" color="#ed4014"/> 停止</a>
                      </Button>
                    </li>
                    <li class="cluster-container-list-li">
                      <Tooltip>
                        <div slot="content">
                          <p>将容器从集群中剔除，</p>
                          <p>可选择是否同时销毁容器</p>
                        </div>
                        <a style="color: #ed4014" v-on:click="$refs.ExcludingContainer.showModal($route.params.id, item.Id)">剔除</a>
                      </Tooltip>
                    </li>
                    <li class="cluster-container-list-li" v-if="item.State.Status === 'exited'">
                      <Tooltip content="重新部署此容器">
                        <a style="color: #ff9900" v-on:click="redeploy(item)">重新部署</a>
                      </Tooltip>
                    </li>
                  </template>
                </ListItem>
              </List>
            </div>
          </div>
        </div>
      </div>
    </Card>
  </div>
</template>

<script>
import { detailCluster, clusterRedeployContainer, getClusterContainers } from '@/api/container/cluster'
import ActionMenu from '../container/components/ActionMenu'
import ContainerLogs from '../container/components/containerLogs'
import InspectModal from '../container/components/inspect'
import DeleteCluster from './components/delete-cluster'
import ExcludingContainer from './components/excluding-container'
import JoinExistedContainer from './components/join-existed-container'
import TemplateSelector from '../template/components/selector'
import Deploy from '../template/deploy'
import moment from 'moment'
import { codemirror } from 'vue-codemirror-lite'
import 'codemirror/theme/mbo.css'
import 'codemirror/mode/yaml/yaml.js'
import 'codemirror/keymap/sublime.js'
import 'codemirror/addon/display/fullscreen.js'
import 'codemirror/addon/display/fullscreen.css'
import 'codemirror/addon/display/autorefresh'
import 'codemirror/addon/hint/show-hint.css'
import 'codemirror/addon/hint/show-hint.js'
import 'codemirror/addon/fold/foldgutter.css'
import 'codemirror/addon/fold/foldgutter.js'
import 'codemirror/addon/fold/foldcode.js'

export default {
  name: 'detail',
  components: {
    ActionMenu,
    ContainerLogs,
    InspectModal,
    DeleteCluster,
    ExcludingContainer,
    JoinExistedContainer,
    TemplateSelector,
    Deploy,
    codemirror
  },
  data () {
    return {
      infoGetting: false,
      infoError: false,
      info: {},
      containers: {},
      containersGetting: false,
      actionLoading: false,
      ordering: '',
      ascending: false,
      orderList: [
        { value: 'Name', label: '容器名称' },
        { value: 'Created', label: '部署时间' },
        { value: 'node_name', label: '节点' },
        { value: 'Status', label: '状态' }
      ],
      moment: moment,
      redeployError: null,
      reDeploying: false,
      redeployYAMLError: false,
      redeployYAMLModal: false,
      redeployForm: {
        container_id: '',
        renew_config: false,
        yaml: ''
      },
      yamlShowModal: false,
      showYamlContent: '',
      cmOption: {
        mode: {
          name: 'yaml'
        },
        lineNumbers: true,
        matchBrackets: true,
        styleActiveLine: true,
        lineWrapping: true,
        theme: 'mbo',
        keyMap: 'sublime',
        smartIndent: false,
        autoRefresh: true,
        foldGutter: true,
        autoCloseBrackets: true,
        cursorHeight: 0.85,
        showCursorWhenSelecting: true,
        // 在行槽中添加行号显示器、折叠器、语法检测器
        gutters: ['CodeMirror-linenumbers', 'CodeMirror-foldgutter', 'CodeMirror-lint-markers'],
        // 快捷键
        extraKeys: {
          'Ctrl': 'autocomplete',
          'F11': function (cm) {
            cm.setOption('fullScreen', !cm.getOption('fullScreen'))
          },
          'Esc': function (cm) {
            if (cm.getOption('fullScreen')) cm.setOption('fullScreen', false)
          }
        }
      }
    }
  },
  computed: {
    myCodeMirror () {
      let editor = this.$refs.myCm.editor
      editor.refresh()
      return editor
    }
  },
  '$route' () {
    if (this.$route.params.id && this.$route.params.nodeId) {
      this.getInfo()
      this.getClusterContainersData()
    }
  },
  created: function () {
    this.getInfo()
    this.getClusterContainersData()
  },
  methods: {
    getInfo () {
      this.infoGetting = true
      this.infoError = false
      detailCluster(this.$route.params.id).then(res => {
        this.info = res.data
        this.infoGetting = false
      }).catch(res => {
        this.infoGetting = false
        this.infoError = true
        console.error(res.response)
      })
    },
    getClusterContainersData () {
      let reqData = {
        ordering: this.ordering,
        ascending: this.ascending
      }
      this.containersGetting = true
      getClusterContainers(this.$route.params.id, reqData).then(res => {
        this.containersGetting = false
        this.containers = res.data
      }).catch(res => {
        this.containersGetting = false
        console.error(res.response)
      })
    },
    redeploy (item) {
      if (item.yaml) {
        this.redeployForm.renew_config = false
        this.redeployForm.yaml = item.yaml
        this.redeployForm.container_id = item.Id
        this.redeployYAMLModal = true
        return
      }
      let reqData = {
        container_id: item.Id
      }
      this.$Modal.confirm({
        title: `重新部署容器`,
        content: `<p>重新部署将删除原有容器，重新部署一台相同配置的容器</p><p>确定要重新部署容器「${item.Name}」吗？</p>`,
        loading: true,
        okText: '重新部署',
        onOk: () => {
          this.redeployError = null
          clusterRedeployContainer(this.$route.params.id, reqData).then(res => {
            this.$Modal.remove()
            this.$Notice.success({title: `操作成功`, desc: `正在部署新的容器「${res.data.Name}」`})
            this.getClusterContainersData()
          }).catch(res => {
            this.$Modal.remove()
            if (res.request) {
              this.$Notice.error({
                title: '重新部署操作失败！',
                desc: res.request.responseText
              })
              this.redeployError = res.response.data
            } else {
              this.$Notice.error({
                title: '重新部署操作失败！'
              })
              this.redeployError = '重新部署操作失败！'
            }
          })
        }
      })
    },
    yamlView (item) {
      this.yamlShowModal = true
      if (item.yaml) {
        this.showYamlContent = item.yaml
      } else {
        this.$Notice.error({
          title: '此容器无YAML配置！'
        })
      }
    },
    reDeploySubmit () {
      this.redeployYAMLError = null
      this.reDeploying = true
      clusterRedeployContainer(this.$route.params.id, this.redeployForm).then(res => {
        this.$Notice.success({title: `操作成功`, desc: `正在部署新的容器「${res.data.Name}」`})
        this.getClusterContainersData()
        this.redeployYAMLModal = false
        this.reDeploying = false
      }).catch(res => {
        this.reDeploying = false
        if (res.request) {
          this.$Notice.error({
            title: '重新部署操作失败！',
            desc: res.request.responseText
          })
          this.redeployYAMLError = res.response.data
        } else {
          this.$Notice.error({
            title: '重新部署操作失败！'
          })
          this.redeployYAMLError = '重新部署操作失败！'
        }
      })
    },
    joinContainer (name) {
      switch (name) {
        case 'existed-container':
          this.$refs.JoinExistedContainer.showModal(this.$route.params.id)
          break
        case 'deploy-new-container':
          this.$refs.TemplateSelector.openSelectModal()
          break
      }
    },
    selectTemplateOk (data) {
      this.$refs.Deploy.showModal(data.id, this.$route.params.id)
    },
    action (index, action) {
      this.actionLoading = true
      this.$refs.ActionMenu[index].actionTrigger(action)
    },
    actionCallBack () {
      this.actionLoading = false
      this.getClusterContainersData()
    }
  }
}
</script>

<style lang="less">
  @import '../../base.less';
  .cluster-container-list-li {
    a {
      line-height: 16px;
      .ivu-icon {
        height: 16px;
      }
    }
  }
</style>
